module.exports = __webpack_public_path__ + "static/img/组 2854.b5f96e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/组 2854.png
// module id = ktXr
// module chunks = 0